export enum QueryParams {
    input = 'input',
    labels = 'labels',
    torques = 't',
    forces = 'f'
}

export enum TorqueLevel {
    Low,
    High,
}

export enum ActuatorTypes {
    NonFailSafe,
    FailSafe,
    HarshEnvironment,
    Fast,
    Linear,
    OutdoorProtected,
    AirflowMeasurementAndControl,
}
